import Http from '@/http'

//演示接口
const librariesUrl = '/libraries.min.json';
export const librariesApi = function (params) {
    return Http.fetch(librariesUrl, params);
};

//灯具DIY相关接口
// 获取配件分类
const categoriesUrl = '/api/lamp/categories';
export const getCategoriesApi = function (params) {
    return Http.fetch(categoriesUrl, params);
};

// 根据类型获取配件
const partsByTypeUrl = '/api/lamp/parts-by-type';
export const getPartsByTypeApi = function (params) {
    return Http.fetch(partsByTypeUrl, params);
};

// 获取配件详情
const partDetailUrl = '/api/lamp/part-detail';
export const getPartDetailApi = function (params) {
    return Http.fetch(partDetailUrl, params);
};

// 获取兼容配件
const compatiblePartsUrl = '/api/lamp/compatible-parts';
export const getCompatiblePartsApi = function (params) {
    return Http.fetch(compatiblePartsUrl, params);
};

// 创建灯具组合
const createCombinationUrl = '/api/lamp/create-combination';
export const createCombinationApi = function (params) {
    return Http.post(createCombinationUrl, params);
};

// 获取组合详情
const combinationDetailUrl = '/api/lamp/combination-detail';
export const getCombinationDetailApi = function (params) {
    return Http.fetch(combinationDetailUrl, params);
};

// 获取用户的组合列表
const combinationListUrl = '/api/lamp/combination-list';
export const getCombinationListApi = function (params) {
    return Http.fetch(combinationListUrl, params);
};

// 删除组合
const deleteCombinationUrl = '/api/lamp/delete-combination';
export const deleteCombinationApi = function (params) {
    return Http.fetch(deleteCombinationUrl, params);
};

// 获取BOM表
const getBomUrl = '/api/lamp/get-bom';
export const getBomApi = function (params) {
    return Http.post(getBomUrl, params);
};

// 获取空间列表
const spacesUrl = '/api/lamp/spaces';
export const getSpacesApi = function (params) {
    return Http.fetch(spacesUrl, params);
};

// 获取场景风格列表
const sceneStylesUrl = '/api/scene/scene-styles';
export const getSceneStylesApi = function (params) {
    return Http.fetch(sceneStylesUrl, params);
};

// 获取场景尺寸列表
const sceneSizesUrl = '/api/scene/scene-sizes';
export const getSceneSizesApi = function (params) {
    return Http.fetch(sceneSizesUrl, params);
};

// 获取场景灯光列表
const sceneLightsUrl = '/api/scene/scene-lights';
export const getSceneLightsApi = function (params) {
    return Http.fetch(sceneLightsUrl, params);
};

// 获取场景预算列表
const sceneBudgetsUrl = '/api/scene/scene-budgets';
export const getSceneBudgetsApi = function (params) {
    return Http.fetch(sceneBudgetsUrl, params);
};

// 用户中心相关接口
// 用户登录
const userLoginUrl = '/api/user/login';
export const loginApi = function (params) {
    return Http.post(userLoginUrl, params);
};

// 用户注册
const userRegisterUrl = '/api/user/register';
export const registerApi = function (params) {
    return Http.post(userRegisterUrl, params);
};

// 获取用户信息
const userInfoUrl = '/api/user/info';
export const getUserInfoApi = function (params) {
    return Http.fetch(userInfoUrl, params);
};

// 更新用户信息
const updateUserInfoUrl = '/api/user/update';
export const updateUserInfoApi = function (params) {
    return Http.post(updateUserInfoUrl, params);
};

// 修改密码
const changePasswordUrl = '/api/user/change-password';
export const changePasswordApi = function (params) {
    return Http.post(changePasswordUrl, params);
};

// 获取用户作品列表
const userWorksUrl = '/api/user/works';
export const getUserWorksApi = function (params) {
    return Http.fetch(userWorksUrl, params);
};

// 获取用户作品详情
const userWorkDetailUrl = '/api/user/work-detail';
export const getUserWorkDetailApi = function (params) {
    return Http.fetch(userWorkDetailUrl, params);
};

// 删除用户作品
const deleteUserWorkUrl = '/api/user/delete';
export const deleteUserWorkApi = function (params) {
    return Http.post(deleteUserWorkUrl, params);
};

// 参数相关接口
// 获取单个参数
const getParamUrl = '/api/param/get';
export const getParamApi = function (params) {
    return Http.fetch(getParamUrl, params);
};

// 批量获取参数
const batchGetParamUrl = '/api/param/batch-get';
export const batchGetParamApi = function (params) {
    return Http.fetch(batchGetParamUrl, params);
};

// 获取logo
const getLogoUrl = '/api/param/get-logo';
export const getLogoApi = function (params) {
    return Http.fetch(getLogoUrl, params, 'blob');
};

// 获取网站版权信息
const getSiteCopyrightUrl = '/api/param/get';
export const getSiteCopyrightApi = function (params) {
    console.log('getSiteCopyrightApi被调用，URL:', getSiteCopyrightUrl, '参数:', params);
    // 确保code参数始终为site_copyright
    const apiParams = { ...params, code: 'site_copyright' };
    return Http.fetch(getSiteCopyrightUrl, apiParams);
};

// 获取系统状态
const getSystemStatusUrl = '/api/param/get-system-status';
export const getSystemStatusApi = function (params) {
    return Http.fetch(getSystemStatusUrl, params);
};

// 根据筛选条件获取灯具模型
const filteredModelsUrl = '/api/lamp/filter-models';
export const getFilteredModelsApi = function (params) {
    return Http.fetch(filteredModelsUrl, params);
};

// 保存灯具组合
const saveLampCombinationUrl = '/api/lamp/save-lamp-combination';
export const saveLampCombinationApi = function (params) {
    return Http.post(saveLampCombinationUrl, params);
};

// 导出BOM表
const exportBomUrl = '/api/lamp/export-bom';
export const exportBomApi = function (params) {
    return Http.fetch(exportBomUrl, params, 'blob');
};

